module.exports = __webpack_public_path__ + "media/assets/images/message-new-icon-a7d6eb4a218c0efd2e0705274b1d5f43.svg";